export const validation = {
  title: "Title is required",
  description: "Description is required",
  startDate: "Start Date is required",
  endDate: "End Date is required",
  subscription: "Subscription is required",
  status: "Status is required",
  minDiscount: "Minimum Discount is required",
  maxDiscount: "Maximum Discount is required",
  limit: "Limit is required",
};
